export enum EUserType {
    Employee = "Employee",
    Passenger = "Passenger",
    Driver = "Driver",
    Operator = "Operator",
}
  